import { Component, OnInit,LOCALE_ID, Inject } from '@angular/core';
import {environment} from '../../environments/environment';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  _link_texto_legal:string;
  _name_texto_legal:string;
  _logoIriziar:string = environment.urlLogoIrizar;
  _logoZuma:string = environment.urlLogoZuma;

  constructor(
    @Inject(LOCALE_ID) protected localeId: string
  ) { }

  ngOnInit() {

    switch (this.localeId) {
      case "eu":
        this._link_texto_legal = "lege-oharra";
        this._name_texto_legal = "Lege Oharra";
        break;
      default:
        this._link_texto_legal = "texto-legal";
        this._name_texto_legal = "Texto Legal";
    }
    this._logoIriziar = '/'+this.localeId+'/'+environment.urlLogoIrizar;
    this._logoZuma = '/'+this.localeId+'/'+environment.urlLogoZuma;
  }

}
